import React, {Component} from "react";
import './LoadingSlideShow.css';
import {loadingInformation, duplicatingInformation}from "./ProgressBarInformation"
import ProgressBar from "./ProgressBar";
import Authentication from "../../authentication/Authentication";


export default class LoadingSlideshow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingInfo: this.props.showDuplicatingMessage ? duplicatingInformation : loadingInformation,
            loadingIndex: 0
        };

        this.authentication = new Authentication();

    };

    updateIndex = () => {
        const newIndex = (this.state.loadingIndex === this.state.loadingInfo.length - 1 ) ? 0 : this.state.loadingIndex + 1

        this.setState({
            loadingIndex: newIndex
        })
    }

    componentDidMount() {
        this.slideshowInterval = setInterval(this.updateIndex, 5000);
    }

    componentWillUnmount() {
        if (this.slideshowInterval) {
            clearInterval(this.slideshowInterval);
        }
    };

    render() {
        return (
            <div className={"instance-information-container-loading"}>
                <div className={"slideshow-slider"} style={{ transform: `translate3d(${-this.state.loadingIndex * 100}%, 0, 0)` }}>
                    {this.state.loadingInfo.map((info, index) => {
                        return (
                                <div className={"slide"} key={index} style={{backgroundColor: info.colour}}>
                                    <div className={"slide-info"}>
                                        <p className={"slideshow-text"}>
                                            {info.text}
                                        </p>
                                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw slideshow-loading"/>
                                        <ProgressBar percentageProgress={this.props.percentageProgress}/>
                                    </div>
                                </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}